module.exports = ".layout {\r\n    display: -webkit-box;\r\n    display: -ms-flexbox;\r\n    display: flex;\r\n  }\r\n  \r\n  .content {\r\n    margin-left: 250px; /* Same as sidebar width */\r\n    padding: 20px;\r\n    width: calc(100% - 250px);\r\n    -webkit-transition: margin-left 0.3s, width 0.3s;\r\n    transition: margin-left 0.3s, width 0.3s;\r\n  }\r\n  \r\n  .open-sidebar .content {\r\n    margin-left: 60px; /* Adjust based on your collapsed sidebar width */\r\n    width: calc(100% - 60px);\r\n  }\r\n  "


//////////////////
// WEBPACK FOOTER
// ./src/app/common/base/base.component.css
// module id = ./src/app/common/base/base.component.css
// module chunks = main